const BASE_PATHS = new Set(['/business', '/business/settings']);

const PATH_REQUIREMENTS = new Map([
  ['/business/orders', ['operations']],
  ['/business/customers', ['operations']],
  ['/business/reports', ['operations']],
  ['/business/finance', ['operations']],
  ['/business/services', ['services']],
  ['/business/calendar', ['calendar']],
  ['/business/team', ['team']],
  ['/business/shop-orders', ['shop']],
  ['/business/returns', ['shop']],
  ['/business/products', ['shop']],
  ['/business/operations', ['workbench']],
  ['/business/dispatch', ['workbench']],
  ['/business/fleet', ['workbench']],
  ['/business/board', ['workbench']],
  ['/business/zones', ['fieldOperations']],
  ['/business/vehicles', ['fieldOperations']],
  ['/business/wallets', ['fieldOperations']],
  ['/business/scorecards', ['fieldOperations']],
  ['/business/cash-reconciliation', ['cashReconciliation']],
]);

function pathWithoutQuery(path) {
  return path.split(/[?#]/, 1)[0].replace(/\/$/, '') || '/';
}

function requirementForPath(path) {
  const normalized = pathWithoutQuery(path);
  if (BASE_PATHS.has(normalized)) return [];
  if (normalized.startsWith('/business/products/')) return ['shop'];
  if (normalized.startsWith('/business/team/')) return ['team'];
  return PATH_REQUIREMENTS.get(normalized) || null;
}

/** Build additive capabilities from the intersection of tenant and provider entitlements. */
export function buildProviderCapabilities({
  providerModules,
  tenantModules,
  moduleConfigs = {},
  hasTeam = false,
}) {
  const tenantSet = new Set(tenantModules);
  const activeModules = new Set(
    providerModules.filter((moduleKey) =>
      tenantSet.has(moduleKey)
      && moduleConfigs[moduleKey]?.channels?.providerAdminPortal !== false,
    ),
  );

  const hasShop = activeModules.has('shop');
  const hasBooking = activeModules.has('booking');
  const hasHome = activeModules.has('home_services');
  const hasOnline = activeModules.has('online_services');
  const hasServiceModule = hasBooking || hasHome || hasOnline;
  const hasAnyModule = activeModules.size > 0;

  return {
    activeModules: [...activeModules],
    operations: hasAnyModule,
    services: hasServiceModule,
    calendar: hasBooking || hasOnline,
    shop: hasShop,
    // Booking/home businesses must be able to add their first team member.
    team: hasTeam || hasBooking || hasHome,
    workbench: hasShop || hasBooking || hasHome || hasTeam,
    fieldOperations: hasHome || hasTeam,
    cashReconciliation: hasShop || hasTeam,
  };
}

export function isProviderPathAllowed(path, capabilities) {
  const requirements = requirementForPath(path);
  if (requirements === null) return false;
  return requirements.every((capability) => capabilities[capability] === true);
}

export function filterProviderPaths(paths, capabilities) {
  return paths.filter((path) => isProviderPathAllowed(path, capabilities));
}
